export const Manifesto = () => {
    return (
        <section
            data-testid="manifesto-section"
            className="relative px-6 sm:px-10 py-28 sm:py-40 border-t border-white/10 overflow-hidden"
        >
            {/* Vertical red accent line */}
            <div
                aria-hidden="true"
                className="absolute left-6 sm:left-10 top-20 bottom-20 w-px bg-gradient-to-b from-transparent via-[#D91C1C]/60 to-transparent hidden sm:block"
            />

            <div className="relative max-w-[1400px] mx-auto">
                <div className="text-[11px] uppercase tracking-[0.3em] text-[#D91C1C] mb-10 flex items-center gap-3">
                    <span className="h-px w-10 bg-[#D91C1C]" />
                    Manifest
                </div>

                <blockquote
                    data-testid="manifesto-quote"
                    className="font-display uppercase text-white leading-[0.95] tracking-tighter text-4xl sm:text-6xl lg:text-7xl xl:text-8xl max-w-[1100px]"
                >
                    Toto nie je <span className="text-white/40">produkt.</span>{" "}
                    Toto je{" "}
                    <span className="text-[#D91C1C]">nálada</span>{" "}
                    zaliata do{" "}
                    <span className="text-white/40">fľaše.</span>
                </blockquote>

                <p
                    data-testid="manifesto-body"
                    className="mt-12 max-w-2xl text-lg sm:text-xl text-white/60 leading-relaxed"
                >
                    Nepredávame nápoj. Predávame chvíľu, kedy ti je všetko
                    jedno a zároveň ti záleží na všetkom. MAD je o tom, že
                    niektoré veci sa robia preto, lebo musia.
                </p>
            </div>
        </section>
    );
};
